.grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(72px, 1fr));
  gap: var(--tuna-spacing-1);
  max-width: 360px;
  margin: 0 auto;
}

.pair {
  display: flex;
  gap: var(--tuna-spacing-1);
  justify-content: center;
}

.btn {
  min-width: 56px;
}
